/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PostsInputs */

const en_nav_posts = /** @type {(inputs: Nav_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posts`)
};

const tr_nav_posts = /** @type {(inputs: Nav_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makaleler`)
};

/**
* | output |
* | --- |
* | "Posts" |
*
* @param {Nav_PostsInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const nav_posts = /** @type {((inputs?: Nav_PostsInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PostsInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_posts(inputs)
	return tr_nav_posts(inputs)
});